module.exports = __webpack_public_path__ + "assets/img/ic-rocket.a0c1c3ad.svg";